import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getSettlementReportsSettlements,
  SettlementFilter,
  SettlementSortBy,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const SETTLEMENT_REPORTS_QUERY_KEY = "SETTLEMENT_REPORTS";

export const getSettlementReportsQueryKeys = {
  all: [SETTLEMENT_REPORTS_QUERY_KEY],
  filtered: (filters: SettlementFilter[], sortBy: SettlementSortBy) => {
    return [...getSettlementReportsQueryKeys.all, ...filters.sort(), sortBy];
  },
};

export const useSettlementReportsQuery = (
  partyPublicId?: string,
  filters: SettlementFilter[] = [SettlementFilter.All],
  sortBy: SettlementSortBy = SettlementSortBy.DateDesc,
) =>
  useQuery({
    queryKey: getSettlementReportsQueryKeys.filtered(filters, sortBy),
    queryFn: processResponseWithApiProblemDetails(() =>
      getSettlementReportsSettlements(partyPublicId, filters, sortBy),
    ),
    placeholderData: keepPreviousData,
  });
